import * as z from 'zod';

import { validationMessagesMap } from 'src/utils/messages';
import { TRIAL_MODE } from 'src/features/subscriptions/utils/types';

export type SubscriptionFormSchemaValues = z.infer<typeof subscriptionFormSchema>;

/*
 * `trial_mode` is a UI-only discriminator. The three cases are not expressible as one nullable
 * field: an omitted `trial_end` means "use the plan's trial_period_days", an explicit null means
 * "no trial at all", and a date overrides the plan. The modal turns the mode into the right payload.
 */
export const subscriptionFormSchema = z
    .object({
        start_date: z.string(),
        end_date: z.string().optional(),
        service_plan: z.string().nonempty(),
        customer: z.string().nonempty(),
        has_active_billing: z.boolean(),
        trial_mode: z.enum(TRIAL_MODE),
        trial_end: z.string().optional().nullable(),
    })
    .superRefine((values, ctx) => {
        if (values.trial_mode === TRIAL_MODE.CUSTOM && !values.trial_end) {
            ctx.addIssue({
                path: ['trial_end'],
                code: 'custom',
                message: validationMessagesMap.validationErrorRequired,
            });
        }
    });

export type SchedulePlanChangeFormSchemaValues = z.infer<typeof schedulePlanChangeFormSchema>;
export const schedulePlanChangeFormSchema = z.object({
    service_plan: z.string().nonempty(),
    effective_date: z.string().optional().nullable(),
});
